import { Component } from '@angular/core';

@Component({
	selector: 'ifective-forbidden',
	templateUrl: './forbidden.component.html',
	styleUrls: ['./forbidden.component.scss']
})
export class ForbiddenComponent {

	constructor() {

	}
}